<template>
    <div role="button"
         aria-label="Toggle menu"
         class="burger-menu"
         :class="burger_menu_classes"
         @click="$emit('click')">
      <span></span>
      <span></span>
      <span></span>
    </div>
</template>

<script>
export default {
  name: "BurgerMenu",
  props: {
    collapse: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    burger_menu_classes() {
      return {
        collapsed: this.collapse,
        shadow: this.shadow,
        dark: this.dark
      }
    }
  }
}
</script>
